import { Typography } from "antd";
import React, { type FC, use } from "react";
import { FormattedMessage } from "react-intl";

import { FormWrapperContext } from "@dms/modules/DocumentFormModule/context/FormWrapperContext";

import { FieldLabel } from "../../../../appearance/components/shared/form/baseComponents/FieldLabel/FieldLabel";
import { TextAreaInput } from "../DocumentInputs/TextArea";
import { SingleFormContext } from "@dms/modules/SingleFormModule/context/SingleFormContext";

const { Text } = Typography;

export const DocumentNotesField: FC = () => {
    const { isGroupEditor } = use(FormWrapperContext);
    const { isReadOnly } = use(SingleFormContext);
    if (isGroupEditor) {
        return null;
    }

    return (
        <FieldLabel
            className="DMSForm__Item"
            name="notes"
            label={
                <Text strong ellipsis>
                    <FormattedMessage id="app.fields.notes" />
                </Text>
            }
        >
            <TextAreaInput disabled={isReadOnly} />
        </FieldLabel>
    );
};
